import script from "./UndoButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UndoButton.vue?vue&type=script&setup=true&lang=ts"

import "./UndoButton.vue?vue&type=style&index=0&id=9d32a906&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d32a906"]])

export default __exports__